import { Injectable, inject } from "@angular/core";
import { catchError, firstValueFrom, of } from "rxjs";
import { IClaim } from "./claim";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class UserClaimsStore {
    private _claims: IClaim[] = [];
    private readonly http = inject(HttpClient);

    get claims() {
        // send out a copy
        return this._claims.map(c => ({ ...c }));
    }

    async getClaims() {
        const claims = await firstValueFrom(this.claims$);
        this._claims = claims ?? [];

        return this.claims;
    }

    private get claims$() {
        return this.http.get<IClaim[]>("api/user/claims").pipe(catchError(() => of(null)));
    }
}
